export const getUserDetails = async (apiClient) => {
    return apiClient.request("/user/getuserdetails", {
        mockResponse: mockUserDetails
    });
};
export const mockUserDetails = {
    userId: "ServiceDE",
    salutation: "2",
    title: null,
    firstname: "Marc",
    surname: "Wenzler",
    email: "Marc.Wenzler.DEMO_TWDE1@de.trumpf.com",
    phone: "+49715630334317",
    fax: null,
    position: "Testuser Service App deutsch",
    language: "de",
    customerNo: "270763",
    company: "MyTRUMPF DEMO DE",
    street: "Johann-Maus-Straße 2",
    zipCode: "71254",
    city: "Ditzingen",
    state: null,
    country: "DE",
    status: "Activated",
    customerAdmin: "false",
    userRoles: ["confirmed", "service_full", "order_use", "order_read", "service_read", "order_full", "customer"]
};
//# sourceMappingURL=getUserDetails.js.map
